/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimilarRequestSearchContextParties
 */
export interface SimilarRequestSearchContextParties {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContextParties
     */
    unknown?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContextParties
     */
    plaintiff?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContextParties
     */
    defendant?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContextParties
     */
    crossDefendant?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContextParties
     */
    crossComplainant?: Array<string>;
}

export function SimilarRequestSearchContextPartiesFromJSON(json: any): SimilarRequestSearchContextParties {
    return SimilarRequestSearchContextPartiesFromJSONTyped(json, false);
}

export function SimilarRequestSearchContextPartiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequestSearchContextParties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unknown': !exists(json, 'Unknown') ? undefined : json['Unknown'],
        'plaintiff': !exists(json, 'Plaintiff') ? undefined : json['Plaintiff'],
        'defendant': !exists(json, 'Defendant') ? undefined : json['Defendant'],
        'crossDefendant': !exists(json, 'CrossDefendant') ? undefined : json['CrossDefendant'],
        'crossComplainant': !exists(json, 'CrossComplainant') ? undefined : json['CrossComplainant'],
    };
}

export function SimilarRequestSearchContextPartiesToJSON(value?: SimilarRequestSearchContextParties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Unknown': value.unknown,
        'Plaintiff': value.plaintiff,
        'Defendant': value.defendant,
        'CrossDefendant': value.crossDefendant,
        'CrossComplainant': value.crossComplainant,
    };
}


